module.exports = __webpack_public_path__ + "img/pneu.5200ca89.jpg";